/* eslint-disable @typescript-eslint/no-empty-function */
import { AxiosResponse } from 'axios';
import { format, parse } from 'date-fns';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { AuthEnum } from '../enum/auth.enum';
import { Operators } from '../enum/operators.enum';
import { Auth } from '../models/auth.model';
import { ICrmLeadCustomDTO, ICrmLeadEstagioDTO, ICrmLeadHistoricoDTO, IUnidadeCleanDTO, IUserAuthDTO } from '../models/happy-code-api.model';
import { Predicate } from '../models/predicate.model';
import { PageableResponse } from '../models/response.model';
import { useLeadCampanhaService } from '../services/lead-campanha.service';
import { useLeadEstagioService } from '../services/lead-estagio.service';
import { useLeadHistoricoTipoService } from '../services/lead-historico-tipo.service';
import { useLeadHistoricoService } from '../services/lead-historico.service';
import { useLeadOrigemService } from '../services/lead-origem.service';
import { useLeadTarefaTipoService } from '../services/lead-tarefa-tipo.service';
import { useLeadTipoService } from '../services/lead-tipo.service';
import { useNotificationService } from '../services/notification.service';
import { usePaisService } from '../services/pais.service';
import { useUnidadeService } from '../services/unidade.service';
import { useUsuarioService } from '../services/usuario.service';
import { useVwLeadService } from '../services/vwlead.service';
import { getObject, setObject } from '../util/store';
import { useGlobalContext } from './global.service';
import { useEstadoService } from '../services/estado.service';
import { useMunicipioService } from '../services/municipio';
import { useCurriculoService } from '../services/curriculo.service';

//Tipando as Props do contexto
interface PropsUserContext {
	usuario: IUserAuthDTO;
	unidade: IUnidadeCleanDTO;
	token: Auth;
	setToken: React.Dispatch<React.SetStateAction<Auth>>;
	setUsuario: React.Dispatch<React.SetStateAction<IUserAuthDTO>>;
	setUnidade: React.Dispatch<React.SetStateAction<IUnidadeCleanDTO>>;
	state: any;
	setState: any;
	onFiltroRetornoClick: any;
	onChangePesquisa: any;
	refreshLeads: any;
	refresh: any;
	totalLeads: number;
	totalLeadsResultado: number;
	leadSelecionado: ICrmLeadCustomDTO;
	setLeadSelecionado;
	historicosAgrupados: any[];
	fetchHistoricos: any;
	funilView;
	setFunilView;
	leadResponse;
	onPageChange;
	flPossuiFiltro;
	limparFiltros;
	onRemoverBuscaClick;
	setFlModoEdicaoTarefa;
	flModoEdicaoTarefa;
	refreshLeadSelecionado;
	refreshLeadsEstagioEspecifico;
	onHistoricoPageChange;
	historicoResponse: AxiosResponse<PageableResponse<ICrmLeadHistoricoDTO>>;
}

//Valor default do contexto
const DEFAULT_VALUE = {
	isGlobalLoading: false,
	setState: () => { },
	usuario: {} as IUserAuthDTO,
	unidade: {} as IUnidadeCleanDTO,

	token: {
		access_token: null,
	},
	
	logout: () => { }, //função de inicialização
	setToken: () => { }, //função de inicialização
	setUsuario: () => { }, //função de inicialização
	setUnidade: () => { }, //função de inicialização
	setIsGlobalLoading: () => { }, //função de inicialização
	setUsuarioForm: () => { }, //função de inicialização
	// setPopLoading: () => { }, //função de inicialização
	state: null,
	onFiltroRetornoClick: () => { },
	onChangePesquisa: () => { },
	totalLeads: 0,
	totalLeadsResultado: 0,
	refreshLeads: () => { },
	refresh: () => { },
	leadSelecionado: null,
	setLeadSelecionado: () => { },
	fetchHistoricos: () => { },
	historicosAgrupados: null,
	funilView: true,
	setFunilView: () => { },
	onPageChange: () => { },
	leadResponse: null,
	flPossuiFiltro: null,
	limparFiltros: () => { },
	onRemoverBuscaClick: () => { },
	setFlModoEdicaoTarefa: () => { },
	flModoEdicaoTarefa: false,
	refreshLeadSelecionado: () => { },
	refreshLeadsEstagioEspecifico: () => { },
	historicoResponse: null,
	onHistoricoPageChange: () => { },
};

const nameStorageLoginUnidade = '@HappyCode/login/unidade';

//criando nosso contexto UserContext
const LeadContext = createContext<PropsUserContext>(DEFAULT_VALUE);

/**
 * Função que irá conter o estado e função que irá alterar o estado 'setState'
 * quer irá prover o contexto para os componentes filhos da árvore
 */
export const LeadContextProvider = ({ children }: any) => {
	const leadCampanhaService = useLeadCampanhaService();
	//const leadStatusService = useLeadStatusService();
	const leadEstagioService = useLeadEstagioService();
	const paisService = usePaisService();
	const municipioService = useMunicipioService();
	const estadoService = useEstadoService();
	const leadTipoService = useLeadTipoService();
	const leadOrigemService = useLeadOrigemService();
	const leadTarefaTipoService = useLeadTarefaTipoService();
	const unidadeService = useUnidadeService();
	const curriculoService = useCurriculoService();
	//const leadService = useLeadService();
	const vwLeadService = useVwLeadService();
	const usuarioService = useUsuarioService();
	const leadHistoricoTipoService = useLeadHistoricoTipoService();
	const notification = useNotificationService();
	const leadHistoricoService = useLeadHistoricoService();

	const [funilView, setFunilView] = useState(true);
	const [flModoEdicaoTarefa, setFlModoEdicaoTarefa] = useState(false);

	const { setIsGlobalLoading } = useGlobalContext();
	const [usuario, setUsuarioGlobal] = useState(DEFAULT_VALUE.usuario);
	const [unidade, setUnidadeGlobal] = useState(DEFAULT_VALUE.unidade);
	const [token, setTokenGlobal] = useState(DEFAULT_VALUE.token);

	const [leadSelecionado, setLeadSelecionado] = useState<ICrmLeadCustomDTO>();

	//const [historicos, setHistoricos] = useState<ICrmLeadHistoricoDTO[]>();
	const [historicosAgrupados, setHistoricosAgrupados] = useState<any[]>();
	const [leadResponse, setLeadResponse] = useState<any>();
	const [historicoResponse, setHistoricoResponse] = useState<AxiosResponse<PageableResponse<ICrmLeadHistoricoDTO>>>();
	const [page, setPage] = useState<any>();
	const [pageHistorico, setPageHistorico] = useState<any>();
	const [unidadeCarregada, setUnidadeCarregada] = useState(false);


	useEffect(() => {
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);
		const unidadeIdUrl = Number(params.get('u'));
	
		// só atualiza se não tiver unidade definida ou se for diferente da atual
		if (unidadeIdUrl && unidade?.id !== unidadeIdUrl) {
			setUnidade({ id: unidadeIdUrl });
		}
	
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	

	const getToken = () => {
		return getObject(AuthEnum.TOKEN_KEY);
	};

	const setToken = (token) => {
		setObject(AuthEnum.TOKEN_KEY, token);
		setTokenGlobal(token);
	};

	const setUsuario = (usuario) => {
		setObject(AuthEnum.USER_KEY, usuario);
		setUsuarioGlobal(usuario);
	};
	const setUnidade = (unidade) => {
		setObject(nameStorageLoginUnidade, unidade);
		setUnidadeGlobal(unidade);
	};

	const [state, setState] = useState({
		campanhas: [],
		leadStatus: [],
		leadEstagios: [],
		paises: [],
		estados: [],
		cidades: [],
		leadOrigens: [],
		leadHistoricoTipos: [],
		tarefaTipos: [],
		leadTipos: [],
		unidades: [],
		curriculos: [],
		boards: [],
		boardsFiltrados: [],
		boardsTemp: [],
		leadId: null,
		flRefresh: false,
		qtLeadsPorPaginas: 10,
		filtro: {
			flFiltrar: false,
			flResetarBoard: false,
			flFiltrarHistoricos: false,
			futuro: false,
			hoje: false,
			atrasado: false,
			novo: false,
			busca: '',
			tipoDataParaFiltrar: null,
			leadOrigemParaFiltrar: null,
			leadDataInicioParaFiltrar: null,
			leadDataFimParaFiltrar: null,
			avaliacaoParaFiltrar: null,
			produto: false,
			campanha: false,
		},
	});

	const filtroDefault = {
		flFiltrar: false,
		flFiltrarHistoricos: false,
		futuro: false,
		hoje: false,
		atrasado: false,
		novo: false,
		busca: '',
		tipoDataParaFiltrar: null,
		leadOrigemParaFiltrar: null,
		leadDataInicioParaFiltrar: null,
		leadDataFimParaFiltrar: null,
		avaliacaoParaFiltrar: null,
		produto: false,
		campanha: false,
	};

	useEffect(() => {
		if (unidade?.id && (state?.filtro?.busca?.length >= 3 || state?.filtro?.busca?.length === 0)) {
			const typingTimeout = setTimeout(() => {
				refreshLeads();
			}, 800);
			return () => clearTimeout(typingTimeout);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state?.filtro?.busca]);

	useEffect(() => {
		if (unidade?.id && state?.filtro?.flFiltrar) {
			refreshLeads();
		}
		if (unidade?.id && state?.filtro?.flFiltrarHistoricos && leadSelecionado?.id) {
			fetchHistoricos();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state?.filtro]);

	useEffect(() => {
		if (unidade?.id && page !== null && page !== undefined) {
			refreshLeads();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page]);

	useEffect(() => {
		if (unidade?.id && pageHistorico !== null && pageHistorico !== undefined) {
			fetchHistoricos();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pageHistorico]);

	const totalLeadsResultado = useMemo(() => {
		if (!funilView) {
			return leadResponse?.data?.['numberOfElements'] || 0;
		}
		if (state?.boards) {
			return state?.boards?.map((item: any) => item?.leads?.length).reduce((a, b) => a + b, 0);
		}
		return 0;
	}, [state?.boards, funilView, leadResponse]);

	const totalLeads = useMemo(() => {
		if (!funilView) {
			return leadResponse?.data?.['totalElements'] || 0;
		}

		if (state?.boards) {
			return state?.boards?.map((item: any) => item?.totalElements || 0).reduce((a, b) => a + b, 0);
		}
		return 0;
	}, [state?.boards, funilView, leadResponse]);

	const onChangePesquisa = (e: any) => {
		setState((state) => {
			state.filtro.busca = e.target.value;
			return { ...state, filtro: { ...state.filtro, flResetarBoard: true } };
		});
	};

	const onPageChange = (event, page) => {
		event.preventDefault();
		setPage(page);
	};

	const onHistoricoPageChange = (event, page) => {
		event.preventDefault();
		setPageHistorico(page);
	};

	useEffect(() => {
		if (unidadeCarregada && unidade?.id && (funilView === true || funilView === false)) {
			refreshLeads();
		}
	}, [unidadeCarregada, funilView]);
	

	const aplicarFiltros = async (estagio?, incrementPage = false) => {
		const predicate = new Predicate();
		if (!unidade?.id) {
			return [];
		}
		
		predicate.sort = 'asc';
		predicate.size = state.qtLeadsPorPaginas;

		if (incrementPage && !estagio?.['last']) {
			predicate.page = estagio?.['number'] + 1;
			// predicate.size = (estagio?.['number'] + 1) * state.qtLeadsPorPaginas;
		}

		page !== null && page !== undefined && predicate.setPage(page);

		estagio && predicate.addOption('estagioCdLeadEstagio', estagio?.cdLeadEstagio, Operators.EQUAL);
		unidade.id && predicate.addOption('unidade.id', unidade.id, Operators.EQUAL);

		if (state?.filtro?.busca?.length > 3) {
			predicate.addMultiOption('dsBusca', state?.filtro?.busca, Operators.CONTAINS);
		}

		predicate.addSort('dataCriacao');

		const dataPredicate = (day?: number, timeLimit?: boolean, timeStart?: boolean) => {
			const dataModificada = new Date();
			dataModificada.setDate(dataModificada.getDate() + day);

			if (timeStart) {
				dataModificada.setHours(0);
				dataModificada.setMinutes(1);
				const dataFormatada = format(dataModificada, "yyyy-MM-dd'T'HH:mm");
				return dataFormatada;
			}
			if (timeLimit) {
				dataModificada.setHours(23);
				dataModificada.setMinutes(59);
				const dataFormatada = format(dataModificada, "yyyy-MM-dd'T'HH:mm");
				return dataFormatada;
			}
			const dataFormatada = format(dataModificada, "yyyy-MM-dd'T'HH:mm");

			return dataFormatada;
		};

		const filtro = state?.filtro;

		if (filtro?.atrasado && filtro?.hoje && filtro?.futuro) {
			predicate.addMultiOption('flPossuiTarefa', true, Operators.EQUAL);
		} else if (filtro?.atrasado && filtro?.hoje) {
			predicate.addMultiOption('proximaTarefa.dhTarefa', dataPredicate(null, true), Operators.LESS_THAN);
		} else if (filtro?.atrasado && filtro?.futuro) {
			predicate.addMultiOption('proximaTarefa.dhTarefa', dataPredicate(null), Operators.LESS_THAN);
			predicate.addMultiOption('proximaTarefa.dhTarefa', dataPredicate(+1, null, true), Operators.GREATER_THAN);
		} else if (filtro?.hoje && filtro?.futuro) {
			predicate.addMultiOption('proximaTarefa.dhTarefa', dataPredicate(null), Operators.GREATER_THAN_OR_EQUAL);
		} else if (filtro?.atrasado) {
			predicate.addMultiOption('proximaTarefa.dhTarefa', dataPredicate(null), Operators.LESS_THAN);
		} else if (filtro?.hoje) {
			predicate.addMultiOption('proximaTarefa.dhTarefa', dataPredicate(null), Operators.GREATER_THAN_OR_EQUAL);
			predicate.addMultiOption('proximaTarefa.dhTarefa', dataPredicate(null, true), Operators.LESS_THAN_OR_EQUAL, true);
		} else if (filtro?.futuro) {
			predicate.addMultiOption('proximaTarefa.dhTarefa', dataPredicate(+1), Operators.GREATER_THAN);
		}

		filtro?.novo && predicate.addMultiOption('flPossuiTarefa', false, Operators.EQUAL);
		filtro?.produto && predicate.addMultiOption('interesses.curriculo.id', filtro?.produto);
		filtro?.campanha && predicate.addMultiOption('campanha.id', filtro?.campanha);
		filtro?.leadOrigemParaFiltrar?.id && predicate.addOption('origem.id', filtro?.leadOrigemParaFiltrar?.id, Operators.EQUAL);
		filtro?.avaliacaoParaFiltrar !== null &&
			filtro?.avaliacaoParaFiltrar !== undefined &&
			predicate.addMultiOption('nrAvaliacaoLead', filtro?.avaliacaoParaFiltrar, Operators.EQUAL);

		const addFiltroData = () => {
			let atributoParaFiltrar;
			const dataInicio = filtro?.leadDataInicioParaFiltrar;
			const dataFim = filtro?.leadDataFimParaFiltrar;

			const dataFinal = parse(dataFim, 'dd/MM/yyyy', new Date());

			dataFinal.setHours(23);
			dataFinal.setMinutes(59);
			const dataFormatada = format(dataFinal, "yyyy-MM-dd'T'HH:mm");


			if (filtro?.tipoDataParaFiltrar === 'data_retorno') {
				atributoParaFiltrar = 'proximaTarefa.dhTarefa';
			}
			if (filtro?.tipoDataParaFiltrar === 'data_criacao') {
				atributoParaFiltrar = 'dataCriacao';
			}

			const dataInicioFormatada = format(parse(dataInicio, 'dd/MM/yyyy', new Date()), "yyyy-MM-dd'T'HH:mm");
			// const dataFimFormatada = format(parse(dataFim, 'dd/MM/yyyy', new Date()), "yyyy-MM-dd'T'HH:mm");

			predicate.addMultiOption(atributoParaFiltrar, dataInicioFormatada, Operators.GREATER_THAN_OR_EQUAL);
			predicate.addMultiOption(atributoParaFiltrar, dataFormatada, Operators.LESS_THAN_OR_EQUAL, true);
			// predicate.addMultiOption(atributoParaFiltrar, 'null', Operators.NOT_EQUAL);
		};

		if (filtro?.tipoDataParaFiltrar?.length > 0 && !!filtro?.leadDataInicioParaFiltrar && !!filtro?.leadDataFimParaFiltrar) {
			addFiltroData();
		}

		const leadResponse = await vwLeadService.findCustomIndex(predicate);

		if (!estagio || !funilView) {
			return leadResponse;
		}

		estagio['totalElements'] = 0;
		if (leadResponse.status >= 200 && leadResponse.status <= 299) {

			if (state?.filtro?.flResetarBoard) {
				estagio.leads = [...leadResponse.data.content];
			} else if (leadResponse.data.number !== estagio.number) {
				estagio.leads = (estagio.leads || []).concat([...leadResponse.data.content]);
			}
			// estagio.leads = state?.filtro?.flResetarBoard ? [...leadResponse.data.content] : (estagio.leads || []).concat([...leadResponse.data.content]);
			estagio['totalElements'] = leadResponse.data.totalElements;
			estagio['totalPages'] = leadResponse.data.totalPages;
			estagio['numberOfElements'] = leadResponse.data.numberOfElements;
			estagio['number'] = leadResponse.data.number;
			estagio['size'] = leadResponse.data.size;
			estagio['last'] = leadResponse.data.last;
		}
		return estagio;
	};

	const refreshLeads = async (estagiosTemp: ICrmLeadEstagioDTO[] = null, flExibirLoading = true) => {
		flExibirLoading && setIsGlobalLoading(true);
		let estagios = estagiosTemp || state?.boards;

		if (funilView) {
			estagios = await Promise.all(
				estagios.map(async (estagio: ICrmLeadEstagioDTO) => {
					return await aplicarFiltros(estagio);
				})
			);
			setState((state) => ({
				...state,
				boards: [...estagios],
				boardsTemp: [...estagios],
				flRefresh: true,
				filtro: { ...state?.filtro, flFiltrar: false },
			}));
		} else {
			const leadResponse = await aplicarFiltros();
			setLeadResponse(leadResponse);
		}

		flExibirLoading && setIsGlobalLoading(false);

		return Promise.resolve();
	};

	const refreshLeadsEstagioEspecifico = async (estagiosTemp: ICrmLeadEstagioDTO) => {
		if (funilView) {
			setIsGlobalLoading(true);
			const estagio = await aplicarFiltros(estagiosTemp, true);
			setState((state) => {
				const novosBoards = state?.boards?.map?.((board) => {
					if (estagiosTemp.cdLeadEstagio === board?.cdLeadEstagio) {
						board = { ...estagio };
					}
					return board;
				});
				return {
					...state,
					boards: novosBoards,
					boardsTemp: novosBoards,
					flRefresh: true,
					filtro: { ...state?.filtro, flFiltrar: false, flResetarBoard: false },
				};
			});
			setIsGlobalLoading(false);
			return estagio;
		}
	};

	const onFiltroRetornoClick = (tipo, valor) => {
		setPage(null);
		setState((state) => ({
			...state,
			filtro: {
				...state.filtro,
				[tipo]: valor,
				flFiltrar: true,
				flResetarBoard: true,
			},
		}));
	};

	const refresh = async () => {
		if (!unidade?.id) {
			return [];
		}
		
		const predicate = new Predicate();
		predicate.addSort('nrLeadEstagioOrdem');

		const estagios: ICrmLeadEstagioDTO[] = await leadEstagioService.findList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, leadEstagios: response.data }));
				return response.data;
			}
			return null;
		});

		if (!estagios) {
			return;
		}

		await refreshLeads(estagios, true);
	};

	useEffect(() => {
		if (unidadeCarregada && state?.qtLeadsPorPaginas && token && unidade?.id) {
			setIsGlobalLoading(true);
			refresh();
			setIsGlobalLoading(false);
		}
	}, [unidadeCarregada, state?.qtLeadsPorPaginas]);
	

	const aplicarFiltroHistorico = (predicate: Predicate) => {
		// state?.filtroHistorico && state?.filtroHistorico?.[] &&
		//   predicate.addOption('leadHistoricoTipo.cdTipoLeadHistorico', state?.filtro?.leadHistoricoTipo);
	};
	const fetchHistoricos = (novosPredicate?: Array<any>) => {
		setIsGlobalLoading(true);
		const predicate = new Predicate();
		predicate.addOption('ativo', true);
		predicate.sort = 'asc';
		predicate.addOption('lead.id', leadSelecionado!.id);
		predicate.addSort('dataCriacao');
		predicate.setPage(pageHistorico);

		novosPredicate?.forEach((pred) => {
			predicate.addMultiOption(pred.key, pred.value);
		});

		setState((state) => ({
			...state,
			filtro: { ...state?.filtro, flFiltrarHistoricos: false },
		}));

		aplicarFiltroHistorico(predicate);

		leadHistoricoService
			.find(predicate)
			.then((response) => {
				if (response.status === 200) {
					setHistoricoResponse(response);
					const data = response.data?.content;
					//setHistoricos(response.data?.content.reverse());

					const groups = data.reduce((groups, game) => {
						const date = format(new Date(game.dataCriacao), 'yyyy-MM');
						if (!groups[date]) {
							groups[date] = [];
						}
						groups[date].push(game);
						return groups;
					}, {});

					const groupArrays = Object.keys(groups).map((date) => {
						return {
							data: date,
							leads: (groups[date] as []).sort((a: ICrmLeadHistoricoDTO, b: ICrmLeadHistoricoDTO) => {
								if (a.dataCriacao < b.dataCriacao) {
									return 1;
								}

								if (a.dataCriacao > b.dataCriacao) return -1;

								return 0;
							}),
						};
					});

					setHistoricosAgrupados(groupArrays);
					return;
				}
				throw new Error();
			})
			.catch((e) => {
				notification({
					description: 'Falha ao buscar o histórico',
					type: 'error',
				});
			})
			.finally(() => {
				setIsGlobalLoading(false);
			});
	};

	useEffect(() => {
		if (!unidade?.id || !token) return;

		setIsGlobalLoading(true);


		const predicateNew = new Predicate();
		predicateNew.addOption('unidade.id', unidade?.id)
		const promise1 = leadCampanhaService.findList(predicateNew).then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, campanhas: response.data }));
			}
		});

		const promise2 = leadHistoricoTipoService.findList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, leadHistoricoTipos: response.data }));
			}
		});

		const promise3 = paisService.findCleanList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, paises: response.data }));
			}
		});

		const promise4 = estadoService.findCleanList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, estados: response.data }));
			}
		});

		const promise5 = municipioService.findCleanList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, cidades: response.data }));
			}
		});

		const promise6 = leadTipoService.findList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, leadTipos: response?.data }));
			}
		});

		const promise7 = leadOrigemService.findList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, leadOrigens: response?.data }));
			}
		});

		const promise8 = unidadeService.findCleanList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, unidades: response?.data }));
			}
		});

		const promise9 = curriculoService.findCleanList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, curriculos: response?.data }));
			}
		});

		const promise10 = leadTarefaTipoService.findCleanList().then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, tarefaTipos: response?.data }));
			}
		});

		const promise11 = usuarioService.getPrincipal().then((response) => {
			setUsuario(response.data);
		});

		const predicate = new Predicate();
		predicate.addOption('ativo', true);
		predicate.addOption('usuarioUnidades.unidade.id', unidade?.id);
		usuarioService.findCleanList(predicate).then((response) => {
			if (response.status === 200) {
				setState((state) => ({ ...state, usuarios: response?.data }));
			}
		});
		Promise.all([promise1, promise2, promise3, promise4, promise5, promise6, promise7, promise8, promise9, promise10, promise11, refresh()]).then(() =>
			setIsGlobalLoading(false)
		);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [unidade, token]);

	useEffect(() => {
		const usuario = getObject(AuthEnum.USER_KEY);
		if (usuario) setUsuarioGlobal(usuario);
	
		const unidade = getObject(nameStorageLoginUnidade);
		if (unidade) setUnidadeGlobal(unidade);
	
		const token = getToken();
		if (token) setTokenGlobal(token);
	
		setUnidadeCarregada(true); // ✅ agora pode disparar refresh
	}, []);
	

	useEffect(() => {
		if (!leadSelecionado?.id) return;
		setHistoricosAgrupados(null);
		fetchHistoricos();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [leadSelecionado?.id]);

	const limparFiltros = () => {
		setState((state) => ({
			...state,
			filtro: {
				...filtroDefault,
				busca: state?.filtro?.busca,
				flFiltrar: true,
				flResetarBoard: false,
			},
		}));
	};

	const onRemoverBuscaClick = () => {
		setState((state) => ({
			...state,
			filtro: {
				...state?.filtro,
				busca: '',
				flFiltrar: true,
				flResetarBoard: true,
			},
		}));
	};

	const flPossuiFiltro = useMemo(() => {
		const filtro = state?.filtro;
		return (
			filtro?.flFiltrar ||
			filtro?.futuro ||
			filtro?.hoje ||
			filtro?.atrasado ||
			filtro?.novo ||
			filtro?.tipoDataParaFiltrar ||
			filtro?.leadOrigemParaFiltrar ||
			filtro?.leadDataInicioParaFiltrar ||
			filtro?.leadDataFimParaFiltrar ||
			filtro?.avaliacaoParaFiltrar ||
			filtro?.produto ||
			filtro?.campanha
		);
	}, [state]);

	const refreshLeadSelecionado = () => {
		if (!leadSelecionado?.id) return;

		setIsGlobalLoading(true);
		vwLeadService
			.findCustomIndexById({ id: leadSelecionado.id })
			.then((response) => {
				setLeadSelecionado({ ...response?.data });
			})
			.finally(() => setIsGlobalLoading(false));
	};

	return (
		<LeadContext.Provider
			value={{
				usuario,
				unidade,
				token,
				setToken,
				setUsuario,
				setUnidade,
				state,
				setState,
				onFiltroRetornoClick,
				onChangePesquisa,
				totalLeads,
				totalLeadsResultado,
				refreshLeads,
				refresh,
				leadSelecionado,
				setLeadSelecionado,
				historicosAgrupados,
				fetchHistoricos,
				funilView,
				setFunilView,
				leadResponse,
				onPageChange,
				flPossuiFiltro,
				limparFiltros,
				onRemoverBuscaClick,
				setFlModoEdicaoTarefa,
				flModoEdicaoTarefa,
				refreshLeadSelecionado,
				refreshLeadsEstagioEspecifico,
				historicoResponse,
				onHistoricoPageChange,
			}}
		>
			{children}
		</LeadContext.Provider>
	);
};

export const useLeadContext = (): PropsUserContext => {
	const context = useContext(LeadContext);
	if (!context) throw new Error('useLeadContext must be used within a LeadContextProvider');
	return context;
};
